import { defineStore } from 'pinia';
import type { Scope, UserResponse, Policy, UserInfo, ScopeOptions } from '@/types';
import axios from 'axios';
import { VortecTime } from 'vortec-components-front';

type GeneralStoreType = {
  loader: boolean;
  scopes: Scope[];
  users: UserResponse[];
  session: UserInfo | null;
};

let scopeRequest: Promise<Scope> | null = null;
let userRequest: Promise<UserResponse> | null = null;

export const generalStore = defineStore('generalStore', {
  state: (): GeneralStoreType => {
    return {
      loader: false,
      scopes: [],
      users: [],
      session: null,
    };
  },
  getters: {},
  actions: {
    setLoader(value: boolean) {
      this.loader = value;
    },
    fetchScopes() {
      if (!scopeRequest) {
        scopeRequest = axios
          .get('/api/scopes')
          .then((response) => {
            // this.scopes = response.data;
            this.scopes = response.data.filter((s: Scope) => window.userData?.scopes.includes(s.value as ScopeOptions));
            return response.data;
          })
          .catch((error) => {
            console.error(error);
            return [];
          });
      }
      return scopeRequest;
    },
    fetchUsers() {
      if (!userRequest) {
        userRequest = axios
          .get('/api/users')
          .then((response) => {
            this.users = response.data;
            return response.data;
          })
          .catch((error) => {
            console.error(error);
            return [];
          });
      }
      return userRequest;
    },

    calculateLastActiveTime(lastActive: string | null | undefined) {
      if (!lastActive) {
        return '-';
      }

      const now = Date.now();
      const lastActiveTime = new Date(lastActive).getTime();
      const diffMs = Math.abs(now - lastActiveTime);
      const diffMinutes = Math.floor(diffMs / (1000 * 60));

      if (diffMinutes < 60) {
        return `Пред ${diffMinutes} минути`;
      }

      const diffHours = Math.floor(diffMinutes / 60);
      if (diffHours < 24) {
        return `Пред ${diffHours} часови`;
      }

      const diffDays = Math.floor(diffHours / 24);
      if (diffDays < 10) {
        return `Пред ${diffDays} дена`;
      }

      const diffWeeks = Math.floor(diffDays / 7);
      if (diffDays <= 70) {
        return `Пред ${diffWeeks} недели`;
      }

      const diffMonths = Math.floor(diffDays / 30);
      return `Пред ${diffMonths} месеци`;
    },

    policyStatus(policy: Policy) {
      if (policy.deactivated_at) {
        return 'Деактивирана';
      }

      const now = VortecTime.locationTime();
      const startDate = VortecTime.parse(policy.start_at);
      const endDate = VortecTime.parse(policy.end_at);
      if (now < startDate) {
        return 'Не активна';
      }

      if (now > endDate) {
        return 'Истечена';
      }

      return 'Активна';
    },
    formatMKD(value: number) {
      if (isNaN(value)) {
        value = 0;
      }

      const formattedNumber = new Intl.NumberFormat('mk-MK', {
        minimumFractionDigits: 0,
      }).format(value);

      return `${formattedNumber} ден.`;
    },
    updateSession() {
      return axios
        .get('/api/session')
        .then((response) => {
          window.userData = response.data;
          this.session = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchSession() {
      return axios.get('/api/session');
    },
    logUserActivity(logData: { activity: string; access_type: string }) {
      return axios.post('/api/user-logs-internal', logData).catch((error) => {
        console.error(error);
      });
    },
  },
});
